import React from 'react';

const TeamMembers = [
  {
    name: 'Dr. Aimee Devlin',
    role: 'Psychiatrist',
    image: 'images/founder-img1.png'
  },
  {
    name: 'Dr. Aimee Devlin',
    role: 'Psychiatrist',
    image: 'images/founder-img2.png'
  },
  {
    name: 'Dr. Aimee Devlin',
    role: 'Psychiatrist',
    image: 'images/founder-img3.png'
  }
];

const Team = () => {
  return (
    <div className="founder-main-wrapper float_left">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="page-2-heading">
              <h4>
                Our <span>Team</span>
              </h4>
            </div>
          </div>

          {TeamMembers.map((member, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={index}>
              <div className="sb-founder-section pt-5">
                <img src={member.image} alt={member.name} />
                <section>
                  <div className="sb-service-section2 bg-change2">
                    <h6>{member.name}</h6>
                    <p>{member.role}</p>
                  </div>
                  <div className="hover-type">
                    <a
                      href="appoinment.html"
                      className="d-inline-block w-100 text-center"
                    >
                      Appointment
                    </a>
                  </div>
                </section>
              </div>
            </div>
          ))}

          <div className="col-lg-12 col-md-12 col-12">
            <div className="text-center mt-5">
              <a href="all-dr.html" className="page2-btn bg-change">
                See all Doctors
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
